import { useCallback, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { ReservationService } from '../../../services';
import { formatError, snackbarUtils } from '../../../utils';
import useCommonStyles, { blueButtonProps } from '../../../styles/common';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  reservationId: number;
  handleFormDialog: () => void;
}

const CheckOutDialog = (props: Props) => {
  const { isOpen, handleClose, reservationId, handleFormDialog } = props;
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCheckOut = useCallback(async () => {
    try {
      setIsSubmitting(true);
      await ReservationService.checkOut(reservationId);
      handleFormDialog();
      handleClose();
    } catch (error) {
      console.log('check-out erro: ', error.message);
      snackbarUtils.error(formatError(error));
    } finally {
      setIsSubmitting(false);
    }
  }, [reservationId, handleClose, handleFormDialog]);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className={classes.dialog}
      aria-labelledby="simple-dialog-title"
    >
      <DialogTitle
        id="simple-dialog-title"
        className={classes.title}
      >
        Deseja fazer checkout no seu ambiente?
      </DialogTitle>
      <DialogContentText>
        Esta ação não poderá ser revertida.
      </DialogContentText>
      <DialogActions className={classes.actions}>
        <Button
          variant="outlined"
          onClick={handleClose}
          className={commonClasses.outlinedButton}
        >
          Não, Voltar
        </Button>
        <Button
          id="checkout-button"
          onClick={handleCheckOut}
          startIcon={isSubmitting ? <CircularProgress size="1rem" /> : null}
          disabled={isSubmitting}
          className={commonClasses.blueButton}
          {...blueButtonProps}
        >
          Sim, fazer checkout.
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckOutDialog;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dialog: {
      minWidth: 200,
      textAlign: 'center',

      '& .MuiBackdrop-root': {
        backdropFilter: 'blur(40px)'
      },
      '& div > p': {
        color: theme.palette.text.primary,
      }
    },
    title: {
      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
      }
    },
    actions: {
      flexDirection: 'column',
      alignItems: 'flex-end',

      '& > #checkout-button': {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          marginTop: 'unset',
        }
      },

      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        alignItems: 'flex-end'
      }
    },
  })
);